module.exports = __webpack_public_path__ + "img/japan-logo-icon.dbf39f2f.png";